import { ApiError, getFileExtension } from '@gorila-shared-ui/components';
import * as uuid from 'uuid';
import { PaginatedResponse } from '../types/app';
import { Tenant, TenantRequest } from '../types/tenants';
import { getRequest, postRequest, uploadRequest } from './api';
import { URLS } from './urls/urls';

export const getTenants = async (
  page: number = 1,
  search: string = '',
  projection: string = 'full'
): Promise<{
  paginatedResponse?: PaginatedResponse<Tenant>;
  error?: ApiError;
}> => {
  const response = await getRequest(URLS.tenants.all, {
    queryParams: { page, search, projection },
  });
  return {
    paginatedResponse: response?.data,
    error: response?.error,
  };
};

export const createTenant = async (tenant: TenantRequest): Promise<{ error?: ApiError }> => {
  const response = await postRequest(URLS.tenants.create, { body: tenant });
  return {
    error: response?.error,
  };
};

export const updateTenant = async (tenantId: string, tenant: TenantRequest): Promise<{ error?: ApiError }> => {
  const response = await postRequest(URLS.tenants.update(tenantId), {
    body: tenant,
  });
  return {
    error: response?.error,
  };
};

export const createTenantImage = async (tenantId: string, file: File): Promise<{ path?: string; error?: ApiError }> => {
  const myId = uuid.v4();
  const extension = getFileExtension(file.name);
  const response = await uploadRequest(`tenants/${tenantId}/images/${myId}${extension}`, file);

  return {
    path: response?.data?.key,
    error: response?.error,
  };
};
